// @ngInject
export function sdOutsideClickOrTab($window: Document): any {
  return ($scope: ng.IScope, $element: ng.IAugmentedJQuery, attr: any) => {
    let expression = attr.sdOutsideClickOrTab;

    let onOutsideClick = (event: MouseEvent) => {
      let isChild = $element.find(event.target).length > 0;
      if (!isChild) {
        $scope.$evalAsync(expression);
      }
    };

    let onFocusOut = (event: FocusEvent) => {
      if ($element[0] === event.target || $element[0].contains(event.relatedTarget as Node)) {
        return;
      }

      $scope.$evalAsync(expression);
    };

    $window.addEventListener("click", onOutsideClick, true);
    $window.addEventListener("focusout", onFocusOut, true);

    $element.on("$destroy", () => {
      $window.removeEventListener("click", onOutsideClick);
      $window.removeEventListener("focusout", onFocusOut);
    });
  };
}
